import { Check2 } from "react-bootstrap-icons";
import type { FormInt, Interrogatory } from "@/briefpoint-client";
import styles from "./ResponsesNavigator.module.scss";

interface ResponsesNavigatorProps {
  interrogatories: Interrogatory[];
  selectedInterrogatories: Set<number>;
  documentStartingNumber: number;
  formIntsMap: Map<string, FormInt> | null;
}

function getFontSize(value: string | number): number {
  // Count only digits, excluding decimals and other characters
  const digitCount = String(value).replace(/\D/g, "").length;
  // 12px for 1 digit, decreasing by 1px per additional digit with minimum of 6px
  return Math.max(12 - (digitCount - 1), 6);
}

export default function ResponsesNavigator(props: ResponsesNavigatorProps) {
  return (
    <div className={styles.scrollContainer}>
      <div className={styles.responsesGrid}>
        {props.interrogatories.map((item) => {
          // For FROGS, look up the FormInt using the interrogatory.text as the ID
          const formInt = props.formIntsMap?.get(item.text) ?? null;
          const displayNumber =
            formInt?.displayName ??
            props.documentStartingNumber - 1 + item.number;
          const isSelected = props.selectedInterrogatories.has(item.id);
          const fontSize = getFontSize(displayNumber);

          return (
            <div key={item.id} className={styles.responseItem}>
              <div
                className={`${styles.responseNumber} ${isSelected ? styles.selected : ""}`}
                style={{ fontSize: `${fontSize}px` }}
              >
                {displayNumber}
              </div>
              {isSelected && <Check2 className={styles.checkIcon} />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
